import { useRef } from "react";
import { motion, useMotionValue, useSpring, useTransform } from "framer-motion";
import { LOGO_ICON } from "../../lib/content";
import { Wifi } from "lucide-react";

export const NomoexCard3D = ({ className = "" }) => {
  const ref = useRef(null);
  const mx = useMotionValue(0.5);
  const my = useMotionValue(0.5);
  const rotateX = useSpring(useTransform(my, [0, 1], [12, -12]), { stiffness: 140, damping: 18 });
  const rotateY = useSpring(useTransform(mx, [0, 1], [-14, 14]), { stiffness: 140, damping: 18 });
  const shine = useTransform(mx, [0, 1], ["-60%", "160%"]);

  const onMove = (e) => {
    const r = ref.current.getBoundingClientRect();
    mx.set((e.clientX - r.left) / r.width);
    my.set((e.clientY - r.top) / r.height);
  };
  const reset = () => {
    mx.set(0.5);
    my.set(0.5);
  };

  return (
    <div ref={ref} onMouseMove={onMove} onMouseLeave={reset} style={{ perspective: 1400 }} className={className} data-testid="nomoex-card-3d">
      <motion.div
        style={{ rotateX, rotateY, transformStyle: "preserve-3d" }}
        className="pay-card-visual relative aspect-[1.586/1] w-full overflow-hidden p-5 sm:p-7"
      >
        <motion.div style={{ left: shine }} className="pointer-events-none absolute top-[-50%] h-[200%] w-44 rotate-[20deg] bg-white/10 blur-2xl" aria-hidden="true" />
        <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-[#3B5FE8]/40 blur-3xl" aria-hidden="true" />
        <div className="pointer-events-none absolute -bottom-20 -left-10 h-56 w-56 rounded-full bg-[#7B96FF]/20 blur-3xl" aria-hidden="true" />
        <div className="flex items-start justify-between">
          <img src={LOGO_ICON} alt="Nomoex" className="h-8 w-8 rounded-lg bg-white/95 p-1 sm:h-10 sm:w-10 sm:rounded-xl sm:p-1.5" />
          <span className="font-mono text-[8px] uppercase tracking-[0.3em] text-white/50 sm:text-[10px]">Future of money</span>
        </div>
        <div className="mt-4 flex items-center gap-4 sm:mt-8">
          <div className="h-7 w-10 rounded-md bg-gradient-to-br from-amber-200 via-yellow-300 to-amber-500 opacity-90 sm:h-9 sm:w-12" />
          <Wifi size={18} className="rotate-90 text-white/40" />
        </div>
        <div className="absolute bottom-5 left-5 right-5 sm:bottom-7 sm:left-7 sm:right-7">
          <p className="font-mono whitespace-nowrap text-[13px] tracking-[0.18em] text-white/90 sm:text-lg sm:tracking-[0.28em]">5312 •••• •••• 4291</p>
          <div className="mt-2 flex items-end justify-between sm:mt-4">
            <div>
              <p className="text-[8px] uppercase tracking-[0.25em] text-white/40 sm:text-[9px]">Card holder</p>
              <p className="mt-0.5 text-xs font-medium text-white/90 sm:mt-1 sm:text-sm">NOMOEX MEMBER</p>
            </div>
            <p className="font-heading text-lg font-medium text-white sm:text-xl">USDC</p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};
